import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-circle-fill text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  青柠影视
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                免费高清在线影视平台，提供最新电视剧、电影、综艺、动漫和纪录片。每日更新，流畅播放。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
                <Link to="/category/recommend" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">热门推荐</Link>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-600">
                <span>邮箱：contact@qingning.tv</span>
                <span>微信：青柠影视官方</span>
                <span>微博：@青柠影视</span>
                <span>电话：400-888-6666</span>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 青柠影视 QingNing.TV - 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}